module.exports = "//public.zight.com/packs/media/images/slack_logo-4d6c34cb28571257d05400c9cb3d4c4d.svg";